import React from "react"
import styled from "styled-components"

import {
	MobergFontFamily,
	MobergFontSize,
} from "../../../../../Components/MobergFont/MobergFont"
import { MobergRow, MobergColumn } from "../../../../../Moberg"
import { RULER_LENGTH_MM } from "../../../../../Pages/Data/Visualize/DataReview/Calibration/constants"

const getTicks = (max: number, majorSpacing: number, minorSpacing: number) => {
	const count = Math.floor(max / minorSpacing) + 1
	return Array.from({ length: count }, (_, i) => {
		const value = i * minorSpacing
		return { value, variant: value % majorSpacing === 0 ? ("major" as const) : ("mid" as const) }
	})
}

const TICKS = getTicks(RULER_LENGTH_MM, 10, 5)

interface CalibrationRulerProps {
	pxPerMm: number
}

export const CalibrationRuler: React.FC<CalibrationRulerProps> = ({ pxPerMm }) => {
	const rulerWidthPx = pxPerMm * RULER_LENGTH_MM
	return (
		<MobergColumn gap={8} horizontalAlign="flex-start">
			<MobergRow horizontalAlign="flex-start">
				<RulerContainer
					role="img"
					aria-label="50 mm reference ruler"
					style={{ width: `${rulerWidthPx}px` }}
				>
					<div
						style={{ position: "relative", height: "32px" }}
						role="presentation"
						aria-hidden="true"
					>
						{TICKS.map(({ value, variant }, index) => (
							<RulerTick
								key={index}
								style={{ left: `${pxPerMm * value}px` }}
								$variant={variant}
							>
								{variant === "major" && <span>{value}</span>}
							</RulerTick>
						))}
					</div>
				</RulerContainer>
			</MobergRow>
			<MobergRow
				verticalAlign="center"
				horizontalAlign="flex-start"
				style={{ display: "inline-flex", gap: 8, padding: "0 4px" }}
			>
				<div
					style={{
						fontFamily: MobergFontFamily.HEADER,
						fontSize: MobergFontSize.REGULAR,
						fontWeight: 600,
						color: "var(--text-secondary-color)",
						lineHeight: 1.4,
						whiteSpace: "nowrap",
					}}
				>
					Length reference (millimeters)
				</div>
			</MobergRow>
		</MobergColumn>
	)
}

const RulerContainer = styled.div`
	position: relative;
	flex-shrink: 0;
	box-sizing: content-box;
	padding: 20px 20px 10px;
	border-radius: 8px;
	border: 1px solid var(--color-border-default);
	background: var(--color-surface-menu);
	overflow: hidden;
`

const RulerTick = styled.div<{ $variant: "major" | "mid" }>`
	position: absolute;
	bottom: 0;
	width: ${({ $variant }) => ($variant === "major" ? "2px" : "1px")};
	height: ${({ $variant }) => ($variant === "major" ? "24px" : "18px")};
	background: var(--color-text-primary);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;

	span {
		position: absolute;
		top: -20px;
		font-size: 13px;
		font-family: ${MobergFontFamily.HEADER};
		color: var(--text-secondary-color);
		left: 50%;
		transform: translateX(-50%);
	}
`
